/* eslint-disable react/prop-types */
import { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';
import './styles/login-page.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoginForm from './LoginForm.jsx';
import ResetPasswordForm from './ResetPasswordForm.jsx';
import ChangePasswordForm from './ChangePasswordForm.jsx';
import dots from '.././images/dots.svg';
import BannerPanel from './BannerPanel.jsx';
import Logo from '../components/Layout/Logo.jsx';
import SwitchUser from './SwitchUser.jsx';
import withSessionRedirect from '../higherOrderComponents/withSessionRedirect';

class LoginPage extends Component {
  name = 'LoginPage';
  state = {
    data: {
      banners: [],
      cssFile: null,
    },
  };

  componentDidMount() {
    const time = new Date().getTime();
    axios.get(`${this.props.bannersUrl}?time=${time}`).then((response) => {
      this.setData(response.data);
    });
  }

  setData = (data) => {
    this.setState({
      data,
    });
  };

  render() {
    return (
      <div className='login-container'>
        {this.state.data && this.state.data.cssFile && <link rel='stylesheet' type='text/css' href={this.state.data.cssFile} />}
        <img src={dots} alt='' className='icons__decoration--left' />
        <img src={dots} alt='' className='icons__decoration--right' />
        <div>
          <div className='actions-container'>
            <div className='login-form-box-outer'>
              <div className='login-form-box-inner'>
                <Logo forceDesktop />
                <div className='shadowed-box'>
                  <Route path='/login'>
                    <h1 className='form-title'>
                      <FormattedMessage id='Signing in' />
                    </h1>
                  </Route>
                  <Route path='/login_switch/:hash'>
                    <h1 className='form-title'>
                      <FormattedMessage id='Partner context' />
                    </h1>
                  </Route>
                  <Route path='/resetting' exact>
                    <h1 className='form-title'>
                      <FormattedMessage id='Password resetting' />
                    </h1>
                  </Route>
                  <Route path='/resetting/:hash'>
                    <h1 className='form-title'>
                      <FormattedMessage id='Password change' />
                    </h1>
                  </Route>
                  <Route path='/setting/:hash'>
                    <h1 className='form-title'>
                      <FormattedMessage id='Password set' />
                    </h1>
                  </Route>
                  <Route path='/login'>
                    <LoginForm />
                  </Route>
                  <Route path='/resetting' exact>
                    <ResetPasswordForm />
                  </Route>
                  <Route path='/resetting/:hash'>
                    <ChangePasswordForm hash={this.props.hash} />
                  </Route>
                  <Route path='/setting/:hash'>
                    <ChangePasswordForm hash={this.props.hash} firstTime />
                  </Route>
                  <Route path='/login_switch/:hash'>
                    <SwitchUser />
                  </Route>
                  <hr />
                  <div className='login-help-info'>
                    <FormattedMessage id='Need help?' />
                    {/* eslint-disable-next-line react/no-danger */}
                    <a href='https://www.pragmago.pl/kontakt/' className='login-link' target='_blank' rel='noopener noreferrer preconnect'>
                      <strong>
                        <FormattedMessage id='Contact us' />
                      </strong>
                    </a>
                  </div>
                  <div className='login-help-info'>
                    {/* eslint-disable-next-line react/no-danger */}
                    <a
                      href='https://www.pragmago.pl/bezpieczenstwo/'
                      className='login-link'
                      target='_blank'
                      rel='noopener noreferrer preconnect'
                    >
                      <strong>
                        <FormattedMessage id='Security' />
                      </strong>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='ads-container'>
            <BannerPanel banners={this.state.data.banners} />
          </div>
        </div>
        <div className='login-container-footerContainer'>
          <div
            className='footer-text'
            dangerouslySetInnerHTML={{
              __html: this.props.intl.formatMessage(
                {
                  id: 'Copyright &copy; 2002-{YEAR} PragmaGO. All rights reserved.',
                },
                {
                  YEAR: new Date().getFullYear(),
                }
              ),
            }}
          />
          <a href='https://pragmago.pl/polityka-prywatnosci/' className='footer-text login-link' target='_blank' rel='noopener noreferrer'>
            <FormattedMessage id='Privacy policy' />
          </a>
        </div>
      </div>
    );
  }
}

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state) => state.authReducer),
  withSessionRedirect
);

export default enhance(LoginPage);
